/**
 * Firm-name matching constants shared by the api (name-variants, enrichment) and the web
 * (Firmenname autocomplete ranking).
 */

/** Legal-form tokens ignored when comparing company names (lower-cased). */
export const LEGAL_FORM_SUFFIXES: readonly string[] = [
  // German
  'gmbh', 'ag', 'eg', 'einzelfirma', 'verein', 'stiftung',
  // French / Italian
  'sa', 'sarl', 'sàrl', 'srl',
  // English
  'ltd', 'llc', 'inc', 'plc', 'co',
  // General
  'kg', 'og', 'kgaa',
];

/** Zefix rejects name queries under 3 characters; the autocomplete stem is at least this long. */
export const FIRM_NAME_STEM_MIN_LENGTH = 3;
